"use client";

import { motion } from "motion/react";
import { marqueeItems } from "@/data/marquee";

export function MarqueeSection() {
  // Duplicate the array to guarantee seamless looping transitions
  const duplicatedItems = [...marqueeItems, ...marqueeItems, ...marqueeItems, ...marqueeItems];

  return (
    <section className="w-full bg-white py-8 overflow-hidden select-none border-y border-black/5">
      <div className="relative flex w-full overflow-hidden mask-marquee">
        <motion.div
          animate={{ x: [0, "-50%"] }}
          transition={{
            ease: "linear",
            duration: 25,
            repeat: Infinity,
          }}
          className="flex whitespace-nowrap items-center gap-6 pr-6 min-w-full shrink-0"
        >
          {duplicatedItems.map((item, index) => (
            <div 
              key={`${item}-${index}`} 
              className="flex items-center text-[clamp(1rem,2vw,1.5rem)] font-black uppercase tracking-wider text-black"
            >
              <span>{item}</span>
              <span className="ml-6 text-black/80 font-normal" aria-hidden="true">
                •
              </span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}